

































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CircularProgress extends Vue {
  @Prop({ default: 6, type: Number }) readonly filled!: number
  @Prop({ default: 12, type: Number }) readonly total!: number
  @Prop({ default: 150, type: Number }) readonly size!: number

  describeArc(
    x: number,
    y: number,
    radius: number,
    startAngle: number,
    endAngle: number,
    cuts: number
  ) {
    var nextStartAngle = startAngle + 2
    var nextEndAngle = startAngle + (endAngle - startAngle) / cuts - 2

    var start = this.polarToCartesian(x, y, radius, nextStartAngle)
    var end = this.polarToCartesian(x, y, radius, nextEndAngle)

    var innerRadius = radius - 6
    var innerStart = this.polarToCartesian(x, y, innerRadius, nextStartAngle)
    var innerEnd = this.polarToCartesian(x, y, innerRadius, nextEndAngle)

    var largeArcFlag = nextEndAngle - nextStartAngle <= 180 ? 0 : 1

    const n = (n: number) => (isNaN(n) ? 0 : n)

    var d = [
      'M',
      n(start.x),
      n(start.y),
      'A',
      n(radius),
      n(radius),
      0,
      n(largeArcFlag),
      1,
      n(end.x),
      n(end.y),
      'L',
      n(innerEnd.x),
      n(innerEnd.y),
      'A',
      n(innerRadius),
      n(innerRadius),
      0,
      n(largeArcFlag),
      0,
      n(innerStart.x),
      n(innerStart.y),
      'Z'
    ].join(' ')

    for (var i = 1; i < cuts; i++) {
      nextStartAngle = nextEndAngle + 2
      nextEndAngle = (endAngle / cuts) * (i + 1) + 2

      start = this.polarToCartesian(x, y, radius, nextStartAngle)
      end = this.polarToCartesian(x, y, radius, nextEndAngle)

      innerStart = this.polarToCartesian(x, y, innerRadius, nextStartAngle)
      innerEnd = this.polarToCartesian(x, y, innerRadius, nextEndAngle)

      largeArcFlag = nextEndAngle - nextStartAngle <= 180 ? 0 : 1

      d =
        d +
        ' ' +
        [
          'M',
          n(start.x),
          n(start.y),
          'A',
          n(radius),
          n(radius),
          0,
          n(largeArcFlag),
          1,
          n(end.x),
          n(end.y),
          'L',
          n(innerEnd.x),
          n(innerEnd.y),
          'A',
          n(innerRadius),
          n(innerRadius),
          0,
          n(largeArcFlag),
          0,
          n(innerStart.x),
          n(innerStart.y),
          'Z'
        ].join(' ')
    }

    return d
  }

  polarToCartesian(
    centerX: number,
    centerY: number,
    radius: number,
    angleInDegrees: number
  ) {
    var angleInRadians = ((angleInDegrees + 90) * Math.PI) / 180.0

    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    }
  }
}
